import { useCallback } from 'react';
import { useTrial } from './useSubscriptionStatus';
import { BILLING_BRAND } from '../data/billingBrandConfig';
import toast from 'react-hot-toast';

// =====================================================================
// useReadOnly — NÚCLEO. Enforce de modo solo-lectura cuando la
// suscripción venció. Marca-agnóstico (textos vía billingBrandConfig).
// Con el flag de cobro apagado, useTrial devuelve isReadOnly=false, así
// que guardAction nunca bloquea nada (inerte).
// =====================================================================
export function useReadOnly() {
  const {
    isReadOnly, isGrace, isExpired, isBlocked,
    currentPlan, currentPlanKey, paymentUrl, graceDaysLeft,
  } = useTrial();

  const guardAction = useCallback(
    (callback) => (...args) => {
      if (!isReadOnly) return callback?.(...args);

      const planName = currentPlan?.name || currentPlanKey || 'tu plan';

      if (isBlocked) {
        toast.error(
          `Tu cuenta está bloqueada. Contactá al ${BILLING_BRAND.supportContact}.`,
          { duration: 5000, id: 'read-only-blocked' }
        );
        return;
      }

      toast(
        (t) => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontWeight: 700, fontSize: '13px' }}>Tu suscripción venció</span>
            <span style={{ fontSize: '12px', color: '#71717A' }}>
              Renovar {planName} para seguir operando.
              {graceDaysLeft > 0 && ` Tenés ${graceDaysLeft} días de gracia.`}
            </span>
            {paymentUrl && (
              <a
                href={paymentUrl} target="_blank" rel="noopener noreferrer"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '6px', marginTop: '4px',
                  padding: '6px 12px', borderRadius: '8px', background: '#10B981', color: '#fff',
                  fontSize: '11px', fontWeight: 800, textDecoration: 'none',
                  textTransform: 'uppercase', letterSpacing: '0.08em',
                }}
                onClick={() => toast.dismiss(t.id)}
              >
                Pagar ahora →
              </a>
            )}
          </div>
        ),
        { duration: 6000, id: 'read-only-guard',
          style: { maxWidth: '380px', padding: '16px', border: '1px solid #FDE68A', background: '#FFFBEB' } }
      );
    },
    [isReadOnly, isBlocked, currentPlan, currentPlanKey, paymentUrl, graceDaysLeft]
  );

  return { isReadOnly, isGrace, isExpired, isBlocked, guardAction, currentPlan, currentPlanKey, paymentUrl, graceDaysLeft };
}

export default useReadOnly;
